import {useState,useEffect} from 'react'
// import { Subtitulo, Titulo } from "../../shared/components/Titulos"
import moment from "moment";

import { Logo } from "../../shared/Icons/Logo";
// import { TableInfo } from '../../shared/components/Table';
import { colunas } from './util/columns';
import { LoadingPage } from '../../shared/components/LoadingPage';
import { Table } from '../../shared/components/Table/Table';
// import { Table } from '../../shared/components/Table/Table';

export function ImprimirMovimento() {

  const [movimentos, setMovimentos] = useState<any[]>([])
  const [contato, setContato] = useState<any[]>([])
  const data = localStorage.getItem('movimento')
  const contatoIdentificacao = localStorage.getItem('contato')
  
  useEffect(() => {
    let convertData = [{}]
    let contatoNome=[{}]

    if (contatoIdentificacao) {
      contatoNome = JSON.parse(contatoIdentificacao)
      setContato(contatoNome)
    }

    if (data) { 
      convertData = JSON.parse(data)
    }
    data && setMovimentos(convertData)
  },[data, contatoIdentificacao])

  return (
    <div className="w-full flex flex-col mx-auto px-2">
      <div className="flex flex-row mt-0 mb-6 justify-between items-center">
        <Logo width="5rem"/>
        <div className="flex flex-col items-end">
          <h1 className='text-[1.2rem] font-semibold'>Comunicação Interna</h1>
          <h3 className=''>{moment().format('DD/MM/YYYY')} - {contato}</h3>
        </div>
      </div>
      <div className="w-full flex">
      {
        !movimentos ?
          <div className="h-[80vh] flex justify-center items-center">
            <LoadingPage />
          </div> 
        :
        <Table 
          dataInfo={movimentos}
          columns={colunas}
        />
        // <TableInfo
        //   idTable='tabelaImpressao'
        //   dataSource={movimentos}
        //   columns={colunas}
        // />
      }
      </div>
      <div className="flex flex-wrap flex-col justify-between mt-16">
        <h3 className="mb-4">
          Declaro sob as penas da lei que me encontro plenamente autorizado por {contato} para retirar os produtos acima descriminados.
        </h3>
        <h3 className="mb-4"> Data: {moment().format('DD/MM/YYYY')}</h3>
        <h3 className="mb-6">CPF/CNPJ: ____________________________</h3>
        <h3>Assinatura: ____________________________</h3>
      </div>
    </div>
  )
}